import { Target } from "lucide-react";

import { cn } from "@/lib/utils";

const KpiStatCard = ({
  label,
  value,
  hint,
  icon: Icon,
  infoNode,
  variation,
  progress,
  dataTestId,
  testId,
  className,
  headerClassName,
  labelClassName,
  valueClassName,
  hintClassName,
}) => {
  const finalTestId = dataTestId || testId;
  return (
    <div
      className={cn(
        "flex h-full min-w-0 flex-col rounded-xl border border-white/10 bg-white/[0.04] p-5 shadow-sm shadow-black/20 group relative",
        className,
      )}
      data-testid={finalTestId}
    >
      <div
        className={cn(
          "flex min-w-0 items-start justify-between gap-3",
          headerClassName,
        )}
      >
        <p
          className={cn(
            "min-w-0 flex-1 break-words text-xs font-semibold uppercase tracking-[0.12em] leading-relaxed text-slate-400",
            labelClassName,
          )}
          data-testid={finalTestId ? `${finalTestId}-label` : undefined}
        >
          {label}
        </p>
        {(infoNode || Icon) ? (
          <div className="flex flex-none items-center gap-1">
            {infoNode ?? null}
            {Icon ? <Icon aria-hidden="true" className="mt-0.5 h-4 w-4 flex-none text-lenvia-blue" /> : null}
          </div>
        ) : null}
      </div>
        <div className="flex items-center gap-2 break-words text-xl font-semibold leading-tight tabular-nums text-white [overflow-wrap:anywhere] sm:text-2xl 2xl:text-[2rem]">
            <p
            className={cn(valueClassName)}
            data-testid={finalTestId ? `${finalTestId}-value` : undefined}
            >
            {value}
            </p>
            {variation && (
              <span className={cn(
                  "text-sm font-medium px-2 py-0.5 rounded-full border", 
                  variation.startsWith('+') ? "text-emerald-400 bg-emerald-500/10 border-emerald-500/20" : 
                  variation.startsWith('-') ? "text-rose-400 bg-rose-500/10 border-rose-500/20" : 
                  "text-slate-400 bg-slate-800 border-slate-700"
              )}>
                  {variation.startsWith('+') ? '↑' : variation.startsWith('-') ? '↓' : ''} {variation} vs M-1
              </span>
            )}
        </div>
        {progress !== undefined && progress !== null && (
            <div
              className="mt-2 flex w-fit items-center gap-1.5 rounded-md bg-lenvia-blue/10 px-2 py-1 text-sm font-medium text-blue-300"
              role="progressbar"
              aria-label={`Progression de l'objectif ${label}`}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={Math.max(0, Math.min(100, Number(progress) || 0))}
            >
                <Target aria-hidden="true" className="h-4 w-4" />
                {progress}% de l'objectif
            </div>
        )}
      {hint ? (
        <div className="mt-auto group">
            <p
            className={cn(
                "min-w-0 break-words pt-3 text-sm leading-relaxed text-slate-400 flex items-center gap-1.5 cursor-help",
                hintClassName,
            )}
            data-testid={finalTestId ? `${finalTestId}-hint` : undefined}
            title={hint}
            >
            <span aria-hidden="true" className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-400/50 text-xs text-slate-300">i</span>
            {hint}
            </p>
        </div>
      ) : null}
    </div>
  );
};

export default KpiStatCard;
